import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckinSeatmapSubHeaderComponent } from './checkin-seatmap-sub-header.component';
import { StaticMsgModule } from '@lib/pipes';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [CheckinSeatmapSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [CheckinSeatmapSubHeaderComponent],
})
export class CheckinSeatmapSubHeaderModule {}
